var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgProfileCircle = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08014 8.52003C8.03348 8.51337 7.97348 8.51337 7.92014 8.52003C6.74681 8.48003 5.81348 7.52003 5.81348 6.34003C5.81348 5.13337 6.78681 4.15337 8.00014 4.15337C9.20681 4.15337 10.1868 5.13337 10.1868 6.34003C10.1801 7.52003 9.25348 8.48003 8.08014 8.52003Z",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4935 12.92C11.3068 14.0067 9.7335 14.6667 8.00017 14.6667C6.26684 14.6667 4.6935 14.0067 3.50684 12.92C3.5735 12.2934 3.9735 11.68 4.68684 11.2C6.5135 9.9867 9.50017 9.9867 11.3135 11.2C12.0268 11.68 12.4268 12.2934 12.4935 12.92Z",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00003C14.6668 4.31813 11.6821 1.33337 8.00016 1.33337C4.31826 1.33337 1.3335 4.31813 1.3335 8.00003C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfileCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profile-circle.47d1fb3f.svg";
export { ForwardRef as ReactComponent };